/**
 * 自定义验证封装
 * created by 李智惠 2021-1-10
 */

// 自定义正则
let expChineseName = new RegExp(/^(?!·)(?!.*?·$)[\u4e00-\u9fa5·]{2,10}$/); // 验证中文姓名
let expEnglishName = new RegExp(/^(?!·)(?!.*?·$)[a-zA-Z·]{2,20}$/); // 验证英文姓名
let expPhone = new RegExp(/^1[3456789]\d{9}$/); // 验证手机号码
let expIdCard = new RegExp(/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/); // 验证身份证号码
let expPwd = new RegExp(/^[A-Za-z][A-Za-z0-9]{5,11}$/); // 验证密码
// 自定义验证姓名
export const validateName = (rule, value, callback) => {
    if (!value) {
        return callback(new Error("患者姓名不能为空！"));
    } else {
        if (value != null && value != "") {
            // if (expChineseName.test(value) == false && expEnglishName.test(value) == false) {
            //     return callback(new Error("格式：2-10个汉字、'·'，或2-20个字母、'·'!"));
            // }
            return callback();
        }
        return callback();
    }
    return callback();
}

// 自定义验证电话号码   
export const validatePhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error("电话号码不能为空！"));
    } else {
        if (value != null && value != "") {
            if (expPhone.test(value) == false) {
                return callback(new Error("请输入正确的手机号！"));
            }
            return callback();
        }
        return callback();
    }
    return callback();
}

// 自定义验证患者身份证号
export const validateIdCard = (rule, value, callback) => {
    if (value != null && value != "") {
        if (expIdCard.test(value) == false) {
            return callback(new Error("身份证号码格式错误，请重新输入!"));
        }
        return callback();
    }
    return callback();
}

// 自定义验证密码
export const validatePwd = (rule, value, callback) => {
    if (value === "" || value === null) {
        return callback(new Error("密码不能为空！"));
    } else {
        if (value != null && value != "") {
            if (expPwd.test(value) == false) {
                return callback(new Error("格式：以字母开头，6-12位数字、字母!"));
            }
            return callback();
        }
        return callback();
    }
    return callback();
}

// 自定义验证年龄 - 岁   
export const validateYear = (rule, value, callback) => {
        if (value != null && value != "") {
            if (value < 0) {
                return callback(new Error("岁取值：> 0!"));
            }
            return callback();
        }
        return callback();
    }
    // 自定义验证年龄 - 月   
export const validateMonth = (rule, value, callback) => {
        if (value != null && value != "") {
            if (value < 0 || value > 11) {
                return callback(new Error("请输入0-12的数字"));
            }
            return callback();
        }
        return callback();
    }
    //正数，最多2位小数校验 包含0
export const positiveNum = /(^[0-9][0-9]{0,5}$)|(^[0-9]{1,6}[\.]{1}[0-9]{0,2}$)/;

//正数，最多2位小数校验 不包含0
export const positiveNum2 = /(^[1-9][0-9]{0,5}$)|(^[1-9][0-9]{0,5}[\.]{1}[0-9]{0,2}$)/;


/**
 * 正整数
 * **/
export const positiveInteger = /^[0-9]{0,5}$\d*$/;